import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppInitializationService } from 'app/app-initialization.service';
import { Company } from 'app/models/company.model';
import { CustomFuelInformation } from 'app/models/custom-fuel-information.model';
import { GlobalConfig } from 'app/models/global-config.model';

import { BehaviorSubject } from 'rxjs';

@Injectable()
export class CompanyService {

    _company: any[];
    onChanged: BehaviorSubject<any>;

    constructor(
        private _httpClient: HttpClient,
        private appConfigService: AppInitializationService,
    ) {
        this.onChanged = new BehaviorSubject({});
    }

    getCompanies(): Promise<Array<Company>> {

        return new Promise((resolve, reject) => {
            this._httpClient.get(this.appConfigService.apiConfig["api-url"] + "companies")
                .subscribe((response: any) => {
                    this._company = response;
                    this.onChanged.next(this._company);
                    resolve(response);
                }, reject);
        });
    }

    add(entity: Company): Promise<Company> {

        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "companies/add", entity)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }
    updated(entity: Company): Promise<Company> {

        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "companies/update", entity)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }
    delete(entity: Company): Promise<Company> {
        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "companies/delete", entity)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }

    getGlobalGonfigByCompany(companyId:number): Promise<Array<GlobalConfig>> {

        return new Promise((resolve, reject) => {
            this._httpClient.get(this.appConfigService.apiConfig["api-url"] + "companies/globalconfigbycompany"+"/"+companyId)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }


    addGlobalConfig(entity: GlobalConfig): Promise<GlobalConfig> {

        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "companies/globalconfig/add", entity)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }

    updatedGlobalConfig(entity: GlobalConfig): Promise<GlobalConfig> {

        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "companies/globalconfig/update", entity)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }

    getCustomFuelInformation(companyId:number): Promise<Array<CustomFuelInformation>> {
        return new Promise((resolve, reject) => {
            this._httpClient.get(this.appConfigService.apiConfig["api-url"] + "companies/fuelinformationbycompany"+"/"+companyId)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }

    
    addCustomFuelInformation(entity: CustomFuelInformation): Promise<CustomFuelInformation> {

        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "companies/fuelinformation/add", entity)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }

    updateCustomFuelInformation(entity: CustomFuelInformation): Promise<CustomFuelInformation> {

        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "companies/fuelinformation/update", entity)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }

    deleteCustomFuelInformation(entity: CustomFuelInformation): Promise<CustomFuelInformation> {
        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "companies/fuelinformation/delete", entity)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }
}
